import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useContext } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import CircledIcon from '../CircledIcon';
import { ModalManagementStore } from '../../providers/modal-manager';
import { useNavigate } from 'react-router-dom';

export type NotificationVariant = 'default' | 'pop-up';

export type NotificationData = {
  title: string;
  description: string;
  date: string;
  isRead: boolean;
  action?: string;
  route?: string;
  file?: boolean;

  modal?: boolean;
};

export type NotificationProps = React.PropsWithChildren<{
  notificationData: NotificationData;
  variant?: NotificationVariant;
  className?: string;
  handleAction?: () => void;
  onClick: () => void;
}>;

const Notification = ({
  notificationData,
  variant = 'default',
  className,
  handleAction,
  onClick,
}: NotificationProps) => {
  const { openModal } = useContext(ModalManagementStore);
  const navigate = useNavigate();
  const handleActionDefault = () => {
    if (!notificationData.route) {
      return;
    }
    if (notificationData.file) {
      window.open(`${process.env.PUBLIC_URL}/${notificationData.route}`);
      return;
    }
    if (notificationData.modal) {
      openModal(notificationData.route);
      document.body.click();
      return;
    }

    navigate(notificationData.route);
  };
  return (
    <Container className={`mw-100 notification p-0 ${variant}`}>
      <Container
        onClick={onClick}
        className={`${className} clickable-area d-flex clickable-area-icon-text align-items-start mw-100`}
      >
        <Row className={'me-3'}>
          <Container className={'d-flex align-items-center pe-0'}>
            <Col className={'m-content px-0'}>
              <CircledIcon
                variant={'icon-danger'}
                icon={light('exclamation-circle')}
              />
            </Col>
          </Container>
        </Row>

        <Row className={'w-100 wrapper-row'}>
          <Row className={'title-date-row'}>
            <Col className={'col-9 col-lg-6'}>
              <span className={'text-fs-6 notification-description'}>
                {notificationData.title}
              </span>
            </Col>
            <Col className={'px-0 col-3 col-lg-6 ms-auto text-end'}>
              <span
                className={
                  'd-none d-lg-block text-fs-6 text-light-grey fw-light'
                }
              >
                {`Due on ${notificationData.date}`}
              </span>
              <span
                className={
                  'd-block d-lg-none text-fs-6 text-light-grey fw-light'
                }
              >
                {`${notificationData.date
                  .replace(',', ' ')
                  .split(' ')
                  .slice(0, 2)
                  .join(' ')}`}
              </span>
            </Col>
          </Row>
          <Col className={'col-12 mb-1'}>
            <span className={'text-fs-6 fw-light notification-description'}>
              {notificationData.description}
            </span>
          </Col>
        </Row>
      </Container>
      <Container onClick={onClick} className={'clickable-area-btn mw-100'}>
        {notificationData.action && (
          <Row>
            <Col className={'col-12 btn-action'}>
              <Button size={'sm'} onClick={handleAction || handleActionDefault}>
                {notificationData.action}
              </Button>
            </Col>
          </Row>
        )}
      </Container>
    </Container>
  );
};

export default Notification;
